<template>
  <div>
	<dl v-if="!json.init" class="spe-picture-list" :style="commonStyle" :ddt-area="`component_${json.floorId}_图片列表组件`" ddt-expose="on">
		<!-- 标题背景(1文案标题，2标题图) -->
		<dt
      v-if="jdata.header.type == 1" :style="{ backgroundColor: jdata.header.backgroundColor || jdata.header.backgroundDefaultColor }"
      @click="$sys.dict.href_for_type(jdata.header.jumpContent, jdata.header.jumpType)"
      :data-area="pt()"
      :data-pos="`component_${json.floorId}_图片列表组件.标题_点击跳转`"
      :data-desc="jdata.header.title || ''"
      :dd_name="`${pt()}.component_${json.floorId}_图片列表组件.标题_点击跳转.${jdata.header.title || ''}`"
      :ddt-click="`${pt()}.component_${json.floorId}_图片列表组件.标题_点击跳转.${jdata.header.title || ''}`"
      ddt-pit="标题_点击跳转"
      :ddt-src="jdata.header.title || ''"
      ddt-expose="on"
    >
			<label :style="{ color: jdata.header.titleColor || jdata.header.titleDefaultColor }">{{ jdata.header.title }}</label>
			<span :style="{ color: jdata.header.moreTextColor || jdata.header.moreTextDefaultColor }" v-if="jdata.header.jumpType > 0">{{ jdata.header.moreText }}<i class="iconfont">&#xe669;</i></span>
		</dt>
		<dt style="padding:0;" v-if="jdata.header.type == 2">
			<img v-lazy="jdata.header.backgroundImage" />
		</dt>
		<dd :style="ddStyle">
			<a
        v-for="(el, index) in jdata.imageData"
        :key="index"
        @click="$sys.dict.href(el.jumpUrl)"
        :data-area="pt()"
        :data-pos="`component_${json.floorId}_图片列表组件.坑位${index + 1}_点击跳转`"
        :data-desc="el.image"
        :dd_name="`${pt()}.component_${json.floorId}_图片列表组件.坑位${index + 1}_点击跳转.${el.image}`"
        :ddt-click="`${pt()}.component_${json.floorId}_图片列表组件.坑位${index + 1}_点击跳转.${el.image}`"
        :ddt-pit="`坑位${index + 1}_点击跳转`"
        :ddt-src="el.image"
        ddt-expose="on"
      >
				<img v-lazy="el.image" />
			</a>
		</dd>
	</dl>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
export default {
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
  components: {},
	data() {
		return {};
	},
  inject: ['pt'],
	computed: {
		jdata() {
			return this.json.data || { commonStyle: {}, tabStyle: {}, tabsData: [], header: {} };
		},
		commonStyle() {
			let sty = {}
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
			return sty;
		},
		ddStyle() {
      if(this.jdata.commonStyle.margin > 0){
        let sty = {
          padding: `0 ${this.jdata.commonStyle.margin}px`
        };
        return sty;
      }
		}
	},
	watch: {},
	mounted() {},
	methods: {},
	filters: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-picture-list {
	min-height: 100px;
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100% 100%;
	> dt {
		height: 84px;
		padding: 0 40px;
		display: flex;
		align-items: center;
		label {
			flex: 1;
			font-size: 34px;
		}
		span {
			font-size: 24px;
		}
		img {
			width: 100%;
			height: 100%;
		}
	}
	> dd {
		display: flex;
		a {
			flex: 1;
			margin-left: 10px;
			img {
				width: 100%;
				height: 100%;
			}
		}
		a:nth-of-type(1) {
			margin-left: 0;
		}
	}
}
</style>
